var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelpRound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Level_Selector_Splash",
    "data-name": "Level Selector Splash",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.884,
    height: 75.884,
    viewBox: "0 0 75.884 75.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1.58,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b788f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e3c48"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M37.942,0A37.942,37.942,0,1,1,0,37.942,37.942,37.942,0,0,1,37.942,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6044",
    "data-name": "Path 6044",
    d: "M9.209,11.114a18.12,18.12,0,0,1,5.115-2.9,16,16,0,0,1,5.563-1.045,13.3,13.3,0,0,1,4.021.6,9.781,9.781,0,0,1,3.316,1.738,8.452,8.452,0,0,1,2.236,2.766,8.1,8.1,0,0,1,.821,3.7,8.22,8.22,0,0,1-1.752,5.2,14.536,14.536,0,0,1-5.469,3.982l-2.609,1.219-.824,5.007H16.952l-.492-3c-.064-.462-.119-.893-.163-1.282a8.307,8.307,0,0,1-.072-.923,2.081,2.081,0,0,1,.318-1.257A4.955,4.955,0,0,1,17.87,23.9l1.619-.931c1.031-.591,1.937-1.133,2.719-1.617a10.875,10.875,0,0,0,1.948-1.506,5.31,5.31,0,0,0,1.15-1.669,5.238,5.238,0,0,0,.376-2.062,4.427,4.427,0,0,0-1.7-3.769,6.967,6.967,0,0,0-4.308-1.282,12.019,12.019,0,0,0-2.78.334,29.773,29.773,0,0,0-3.554,1.177l-2.747,1.028Zm6.782,28.392V35.24h3.637a1.259,1.259,0,0,1,.777.163.753.753,0,0,1,.188.591v3.512Z",
    transform: "translate(18.197 14.604)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpRound);
export default __webpack_public_path__ + "static/media/icon_help_round.1309b9f307e4f52348e4eaf12ac09a1c.svg";
export { ForwardRef as ReactComponent };